module.exports = __webpack_public_path__ + "img/facial-recog.06b86bcb.png";